import { useDeferredScript, State } from '@/hooks/useScript';
import { useEffect } from 'react';
import useUser from '@/hooks/useUser';

export function useZendesk() {
  const status = useDeferredScript(
    'https://static.zdassets.com/ekr/snippet.js?key=9df5d642-d58c-4a29-8153-c7a2aed23ebe',
    {
      id: 'ze-snippet',
    }
  );

  useEffect(() => {
    if (status === State.READY) {
      try {
        window.zE('webWidget', 'helpCenter:setSuggestions', {
          labels: ['subscription plans'],
        });
      } catch {
        // noop
      }
    }
  }, [status]);

  const {
    data: { emailAddress, loggedIn },
  } = useUser();

  useEffect(() => {
    if (status === State.READY && loggedIn) {
      try {
        window.zE.identify({
          email: emailAddress,
        });
      } catch {
        // noop
      }
    }
  }, [status, emailAddress, loggedIn]);

  useEffect(() => {
    return () => {
      if (status === State.READY) {
        try {
          /** remove the zendesk snippet script */
          const script = document.getElementById('ze-snippet');
          if (script) {
            script.remove();
          }
          /** delete the zE object from window */
          delete window.zE;
        } catch {
          // noop
        }
      }
    };
  }, [status]);
  return null;
}
